<template>
  <form @submit.prevent="save()" class="ui small form">
    <h3 class="ui header">Configurações de Emissão de NFSe</h3>
    <div class="sixteen wide field">
      <label for="nfse-base-url-setting">URL da API</label>
      <input
        type="text"
        name="nfse-base-url-setting"
        v-model="form.nfse_base_url"
      />
    </div>
    <div class="fields">
      <div class="six wide field">
        <label for="nfse-cnpj-setting">CNPJ</label>
        <input type="text" name="nfse-cnpj-setting" v-model="form.nfse_cnpj" />
      </div>
      <div class="six wide field">
        <label for="nfse-im-setting">Incrição Municipal</label>
        <input type="text" name="nfse-im-setting" v-model="form.nfse_im" />
      </div>
      <div class="six wide field">
        <label for="nfse-ibge-code-setting">Código IBGE</label>
        <input
          type="text"
          name="nfse-ibge-code-setting"
          v-model="form.nfse_ibge_code"
        />
      </div>
    </div>
    <div class="fields">
      <div class="six wide field">
        <label for="nfse-operation-setting">Natureza da Operação</label>
        <input
          type="text"
          name="nfse-operation-setting"
          v-model="form.nfse_operation"
        />
      </div>
      <div class="six wide field">
        <label for="nfse-special-taxation-setting">
          Regime Especial de Tributação
        </label>
        <input
          type="text"
          name="nfse-special-taxation-setting"
          v-model="form.nfse_special_taxation"
        />
      </div>
      <div class="six wide field">
        <label for="nfse-iss-rate-setting">Alíquota ISS</label>
        <input
          type="text"
          name="nfse-iss-rate-setting"
          v-model="form.nfse_iss_rate"
        />
      </div>
    </div>
    <div class="fields">
      <div class="six wide field">
        <label for="nfse-cnae-setting">Código Cnae</label>
        <input type="text" name="nfse-cnae-setting" v-model="form.nfse_cnae" />
      </div>
      <div class="six wide field">
        <label for="nfse-municipal-tax-code-setting">
          Código de Tributação Muncipal
        </label>
        <input
          type="text"
          name="nfse-municipal-tax-code-setting"
          v-model="form.nfse_municipal_tax_code"
        />
      </div>
      <div class="six wide field">
        <label for="nfse-service-code-setting">Código do Serviço</label>
        <input
          type="text"
          name="nfse-service-code-setting"
          v-model="form.nfse_service_code"
        />
      </div>
    </div>
    <div class="inline field">
      <div class="ui checkbox">
        <input
          type="checkbox"
          id="nfse-simple-national-setting"
          v-model="form.nfse_simple_national"
        />
        <label for="nfse-simple-national-setting">
          Optante Simples Nacional
        </label>
      </div>
    </div>
    <div class="inline field">
      <div class="ui checkbox">
        <input
          type="checkbox"
          id="nfse-retain-iss-setting"
          v-model="form.nfse_retain_iss"
        />
        <label for="nfse-retain-iss-setting">ISS Retido</label>
      </div>
    </div>
    <h4 class="ui dividing header">Emissão Automática</h4>
    <div class="inline field">
      <div class="ui checkbox">
        <input
          type="checkbox"
          id="nfse-auto-setting"
          v-model="form.nfse_auto"
        />
        <label for="nfse-auto-setting">
          Emitir nota automaticamente após pagamento
        </label>
      </div>
    </div>
    <div class="field">
      <label for="nfse-description-setting">Descrição da Nota</label>
      <textarea
        v-model="form.nfse_description"
        id="nfse-description-setting"
        rows="8"
        cols="80"
      >
      </textarea>
    </div>
  </form>
</template>
<script>
export default {
  data() {
    return {
      form: {
        nfse_cnpj: null,
        nfse_special_taxation: null,
        nfse_iss_rate: null,
        nfse_im: null,
        nfse_operation: null,
        nfse_simple_national: null,
        nfse_retain_iss: null,
        nfse_description: null,
        nfse_ibge_code: null,
        nfse_service_code: null,
        nfse_auto: null,
        nfse_base_url: null,
        nfse_municipal_tax_code: null,
        nfse_nfse_cnae: null,
      },
    };
  },

  methods: {
    setForm(settings) {
      const formKeys = Object.keys(this.form);
      settings.forEach(setting => {
        if (formKeys.includes(setting.key)) {
          this.form[setting.key] = setting.response;
        }
      });
    },

    getSettings() {
      return this.form;
    },
  },
};
</script>
